import React from "react";
import ModamilyAppButtonGroup from "../form/ModamilyAppButtonGroup";
import ModamilyAppDropDownMenu from "../form/ModamilyAppDropDownMenu";

/**
 * @property {Object} data  - { orientation: null } - default data for the form
 * @property {Function} invalidate - Function that gets called when the form is invalid
 * @property {Function} onValidChange- Function that gets called when the form is valid
 */
export default class ModamilyAppSexualOrientationForm extends React.Component {
  state = {
    data: this.props.data || { orientation: null },
    valid: false,
  };
  componentDidMount = () => {
    let data = this.state.data;
    if (!data.orientation) {
      this.props.invalidate();
    } else {
      this.props.onValidChange(data);
    }
  };
  buttonOptions = ["women", "men", "everyone"];

  updateValue = (key, data) => {
    let stateData = this.state.data;

    if (!data) {
      this.props.invalidate();
    }

    stateData[key] = data;

    let state = this.state;

    state.data = stateData;

    this.setState(state);
    this.onEnterPress();
  };

  onButtonClick = (value, index, isActive) => {
    if (isActive) {
      this.setState(
        {
          data: { orientation: value },
        },
        this.props.onValidChange({ orientation: value })
      );
    } else {
      this.props.invalidate();
    }
  };

  render() {
    let index = this.buttonOptions.indexOf(this.state.data.orientation);
    if (index < 0) {
      index = null;
    }
    return (
      <div className="hairColorForm hasDropdown sexualOrientationForm">
        {/* <ModamilyAppFormHeader text="Sexual Orientation" /> */}
        <div className="ModamilyAppOnboarding__info">
          <h2 className="ModamilyAppOnboarding__info--title">
            Who would you like to meet?
          </h2>
        </div>
        <ModamilyAppButtonGroup
          onButtonClick={this.onButtonClick}
          data={this.buttonOptions}
          type="radio"
          selected={index}
        />
      </div>
    );
  }
}
